'use strict';
'use es6';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchClient = function () {
  function SearchClient() {
    _classCallCheck(this, SearchClient);
  }

  _createClass(SearchClient, [{
    key: 'search',
    value: function search(params, callback) {
      var query = Object.keys(params).map(function (key) {
        return key + '=' + params[key];
      }).join('&');
      return _Ajax2.default.get(SearchClient.apiPath + '?' + query, callback);
    }
  }], [{
    key: 'apiPath',
    get: function get() {
      return '/_hcms/search';
    }
  }]);

  return SearchClient;
}();

window.searchClient = new SearchClient();


//////////////////
// WEBPACK FOOTER
// ./js/SearchClient.js
// module id = 2
// module chunks = 1